import React, {useEffect, useState} from "react";
import axios from "axios";
import {confirmAlert} from "../../Components/Alerts/BasicAlert";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

export default function () {
  const navigate = useNavigate();
  const user = useSelector(state => state.user);
  const isAdminType = user?.isAdminType;

  const [data, setData] = useState({});
  const [errors, setErrors] = useState();
  const [filterParams, setFilterParams] = useState({
    sort_param: 'id',
    sort_direction: 'asc',
  });

  const getData = () => {
    axios.get("dashboard/recent-feedbacks", {params: filterParams}).then(res => {
      if (res.data.status === 'success') {
        setData(res.data);
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }

  useEffect(() => {
    getData()
  }, [...Object.values(filterParams)]);

  console.log(filterParams);

  const deleteFeedback = (id) => {
    confirmAlert('Do you want to delete feedback?', () => {
      axios.delete('feedbacks/' + id).then(res => {
        getData();
      });
    });
  }

  return (
    <>
      <div className="feedbacks-recent rounded bg-main-color px-5 mt-20">
        <div className="row">
          <div className="col-xl-12 mb-5 mb-xl-0">
            <div className="border-bottom">
              {/* shadow */}
              <div className="px-1 py-3 border-0">
                <div className="row align-items-center">
                  <div>
                    <h3 className="mb-0 pt-3 text-muted ls-1 d-inline-block">
                      Recent Reviews
                    </h3>
                    <button
                      type="button"
                      className="btn btn-secondary ml-3"
                      title="See All (Showing last 20 right now)"
                      onClick={() => {
                        navigate('/feedbacks')
                      }}
                    >
                      See All
                    </button>

                    <div className="float-right chart-change">
                      <span className="mr-3 fs-4 fw-bold text-muted">Sort By</span>
                      <select
                        className="form-control form-control-lg form-control-solid d-inline-block w-auto"
                        onChange={(e) => setFilterParams({...filterParams, sort_param: (e.target.value)})}
                        title="Change Feedbacks Sort"
                      >
                        <option key={1} value="">--Column--</option>
                        <option key={2} value="id">ID</option>
                        <option key={3} value="product">Product</option>
                        <option key={4} value="customer">Customer</option>
                        <option key={5} value="stars">Stars</option>
                        <option key={6} value="created_at">Dates</option>
                      </select>
                      <select
                        className="form-control form-control-lg form-control-solid d-inline-block w-auto ml-2"
                        onChange={(e) => setFilterParams({
                          ...filterParams,
                          sort_direction: (e.target.value)
                        })}
                        title="Change Feedbacks Sort"
                      >
                        <option key={1} value="asc">ASC</option>
                        <option key={2} value="desc">DESC</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mb-5">
            <div className="feedback row">
              <table className="table customer-feedbacks align-middle table-row-dashed gy-5 no-footer">
                <thead className="color-dark-grey">
                <tr>
                  <th className="p-0 py-5 pl-3">ID</th>
                  <th className="p-0 py-5 pl-3">Product</th>
                  <th className="p-0 py-5 pl-3">Customer</th>
                  <th className="p-0 py-5 pl-3">Stars</th>
                  <th className="p-0 py-5 pl-3">Date</th>
                  <th className="p-0 py-5 pl-3">Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                  data?.recent_feedbacks?.map((feedback, index) => {
                    return (
                      <tr key={index} className="col-xxl-4 col-xl-6 p-10 mb-lg-0 mb-10">
                        <td className="pl-3 text-muted">
                          {feedback.id}
                        </td>
                        <td
                          className="color-primary cursor-pointer fs-6 ellipsis"
                          title="Open"
                          onClick={() => {
                            navigate(`/products/${feedback.product?.id}/edit`)
                          }}
                        >
                          {feedback?.product?.name}
                        </td>
                        <td
                          className="color-primary cursor-pointer fs-6"
                          title="Open"
                          onClick={() => {
                            navigate(`/customers/${feedback?.user?.id}`)
                          }}
                        >
                          {
                            (feedback?.user?.first_name && feedback?.user?.last_name) ?
                              feedback?.user?.first_name + " " + feedback?.user?.last_name :
                              (feedback?.user?.email ? feedback?.user?.email : feedback?.user?.phone)
                          }
                        </td>
                        <td>
                          {[...Array(feedback?.stars ?? 0)].map((e, i) => <i
                            className="fas fa-star text-warning fs-5 ml-1"></i>)}
                        </td>
                        <td className="fs-6 text-muted">
                          {new Date(feedback?.created_at).toLocaleDateString('en-GB')}
                        </td>
                        <td className="fs-6 text-muted">
                          {
                            isAdminType && (
                              <i
                                className="far fa-trash-alt text-hover-danger cursor-pointer fs-4"
                                title="Delete Review"
                                onClick={() => {
                                  deleteFeedback(feedback?.id)
                                }}
                              ></i>
                            )
                          }
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}